define([
    "./monitoringLocalityModule",
    "./monitoringLocalityRouter",
    "./monitoringLocalityControllerEdition",
    "./monitoringLocalityControllerSearch",
    "./monitoringLocalityService"
], function () {
});